/** Your profile picture: uploading a new one or removing it. */
export const SET_AVATAR = 'PROFILE/SET_AVATAR';
export const REMOVE_AVATAR = 'PROFILE/REMOVE_AVATAR';
export const AVATAR_DONE = 'PROFILE/AVATAR_DONE';
